import { routeNames, routePaths } from '@/router/router-constants'
import type { RouteRecordRaw } from 'vue-router'

export const settingRoutes: RouteRecordRaw[] = [
  {
    path: routePaths.settings,
    name: routeNames.settings,
    component: () => import('@/pages/settings/SettingsView.vue'),
    meta: {
      permission: 'admin',
      icon: 'pi pi-cog',
      labelKey: 'settings',
    },
  },
]
